import { VectorQuantificationRelatoryInteractor } from "../../Coordinator/VectorQuantificationRelatory/VectorQuantificationRelatoryInteractor";

export class VectorQuantificationRelatoryViewModel {

    private interactor: VectorQuantificationRelatoryInteractor
    constructor() {
        this.interactor = new VectorQuantificationRelatoryInteractor()
    }

    public fetchVectorQuantification(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchVectorQuantification(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }

    public fetchVectorQuantificationRelatory(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchVectorQuantificationRelatory(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }
}